import { createAsyncActions } from '../../utils';

export const candidateOverviewConstants = {
  FETCH_CANDIDATE_DETAILS: createAsyncActions('@@candidateOverview/FETCH_CANDIDATE_DETAILS'),
  SET_CANDIDATE_DATA: '@@candidateOverview/SET_CANDIDATE_DATA',

};
export const candidateOverviewActions = {
  fetchCandidateDetails: (payload) => ({
    type: candidateOverviewConstants.FETCH_CANDIDATE_DETAILS.TRIGGER,
    payload,
  }),

  setCandidateData(payload) {
    return {
      type: candidateOverviewConstants.SET_CANDIDATE_DATA,
      payload,
    };
  },
};
